import { UploadTypes } from '../../@types';
import { useGetAllAiMediaData } from '../../services';
import { useDialog } from '../useDialog';

interface Payload {
  isImage: boolean;
}

export const useAiGeneratePage = ({ isImage }: Payload) => {
  const {
    isDialogOpen: isAiGenerateDialogOpen,
    openDialog: openAiGenerateDialog,
    closeDialog: closeAiGenerateDialog,
  } = useDialog();

  const {
    data: aiMediaData,
    isLoading: isLoadingAiMediaData,
    refetch: refetchAiMediaData,
  } = useGetAllAiMediaData({
    type: isImage ? UploadTypes.Image : UploadTypes.Video,
    shouldFetchData: true,
    name: '',
  });

  return {
    isAiGenerateDialogOpen,
    openAiGenerateDialog,
    closeAiGenerateDialog,
    aiMediaData,
    isLoadingAiMediaData,
    refetchAiMediaData,
  };
};
